/**
 * Tile 1: Stripe Connect UI Mock
 */
const TileStripeConnect = () => (
  <div className="border border-neutral-200 bg-neutral-50 rounded-lg p-4 space-y-3">
    <div className="flex flex-col items-center text-center">
      {/* Stripe wordmark-style text */}
      <div className="text-lg font-bold text-[#635bff] tracking-tight mb-2">
        stripe
      </div>
      <p className="text-xs text-neutral-500 mb-3">
        Securely connect to accept payments
      </p>
      <button
        type="button"
        className="w-full bg-[#635bff] text-white text-sm font-medium py-2.5 px-4 rounded-md hover:bg-[#5851db] transition-colors"
      >
        Connect with Stripe
      </button>
    </div>
  </div>
);

export default TileStripeConnect;
